import {Tag} from 'antd'
import Icon from '@ant-design/icons';
import ImageSign from '../components/ImageSign'
import maya from '../js/maya'

const SignTag = (props) => {
    const SignIcon = props => {
       return (<Icon component={propis => (<ImageSign sign={props.sign} {...propis}/>)} {...props}/>);
    }
    var color = "#bbbb00";
    var textColor = "black";
    switch(props.sign%4)
    {
    case 1:
        color = "#ff5555";
        textColor = "white";
        break;
    case 2:
        color = "#aaaaaaff";
        textColor = "black";
        break;
    case 3:
        color = "#0090ff";
        textColor = "white";
        break;
    }
    return (<Tag color={color}
        icon={(<SignIcon sign={props.sign} style={{fontSize: "1.5em"}}/>)} {...props}>
        {props.locale.signs[props.sign]+" ("+props.sign+")"}
    </Tag>);
}
export default SignTag;